import { Typography } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Checkbox } from '~/components';
import WizardForm from '~/components/WizardForm';
import longdash from '~/constants/longdash';
import { NamePath } from '~/utils/buildNamePath';
import { useDirection } from '~/hooks/i18nHooks';
import direction from '~/utils/direction';

interface Props {
  label: string | React.ReactElement;
  name: NamePath;
  children?: React.ReactNode;
  fullWidth?: boolean;
  disabled?: boolean;
}

const ReviewItemCheckbox: FC<Props> = (props) => {
  const dir = useDirection();
  const { children, label, name, fullWidth, disabled } = props;
  return (
    <Container dir={dir}>
      <WizardForm.Item
        name={name}
        valuePropName="checked"
        initialValue={false}
        className="ReviewItemCheckbox"
        disabled={disabled}
      >
        <Checkbox className={fullWidth ? 'ReviewItemCheckbox-FullWidth' : ''}>
          <Typography.Title level={5} className="ReviewItemCheckboxTitle">
            {label}
          </Typography.Title>
          <Typography.Paragraph>
            {children === undefined || children === null ? longdash : children}
          </Typography.Paragraph>
        </Checkbox>
      </WizardForm.Item>
    </Container>
  );
};

const Container = styled.div`
  .ReviewItemCheckbox {
    margin-bottom: 8px;
    width: 100%;
  }
  .ReviewItemCheckbox-FullWidth {
    width: 100%;
    & > span:last-child {
      width: 100%;
      ${direction.padding.right(0)};
    }
  }

  .ReviewItemCheckboxTitle {
    margin-bottom: 8px;
  }
`;

export default ReviewItemCheckbox;
